import { drawCard } from './canvasMethods'
import { Card } from '../Models/Card'
import { getDraggedCards, getCurrentCardState, appState } from './state'
import { getWasteVisibleCount } from './gameRules'
import { isCardAnimating } from './cardPositions'

export function drawFoundation(ctx: CanvasRenderingContext2D) {
    const currentState = getCurrentCardState()
    for (const foundation of currentState.foundation) {
        // Foundation cards are stacked — only draw the top one (always fully visible)
        if (foundation.length > 0) {
            const topCard = foundation[foundation.length - 1]

            if (isCardAnimating(topCard)) {
                // While the new top card is animating from source -> foundation,
                // keep the previous top visible so the foundation slot never appears empty.
                if (foundation.length > 1) {
                    drawCard(foundation[foundation.length - 2], ctx, true)
                }
                continue
            }

            drawCard(topCard, ctx, true)
        }
    }
}

// Draw animating foundation top cards after all piles so they stay visually on top.
export function drawAnimatingFoundationOverlays(ctx: CanvasRenderingContext2D) {
    const currentState = getCurrentCardState()
    for (const foundation of currentState.foundation) {
        if (foundation.length === 0) continue
        const topCard = foundation[foundation.length - 1]
        if (isCardAnimating(topCard)) {
            drawCard(topCard, ctx, true)
        }
    }
}

export function drawWaste(ctx: CanvasRenderingContext2D) {
    const currentState = getCurrentCardState()

    const maxVisible = getWasteVisibleCount(currentState, appState.NUM_CARDS_FLIPPED)
    const firstVisibleIndex = Math.max(0, currentState.waste.length - maxVisible)
    const wasteCards: Card[] = currentState.waste.slice(firstVisibleIndex, currentState.waste.length)

    for (let i = 0; i < wasteCards.length; i++) {
        const isTop = i === wasteCards.length - 1
        drawCard(wasteCards[i], ctx, isTop)
    }
}

export function drawStock(ctx: CanvasRenderingContext2D) {
    const currentState = getCurrentCardState()
    // Stock cards are all stacked on top of each other — only draw the top one
    if (currentState.stock.length > 0) {
        drawCard(currentState.stock[currentState.stock.length - 1], ctx, true)
    }
}

export function drawTableau(ctx: CanvasRenderingContext2D) {
    const currentState = getCurrentCardState()
    for (const tableau of currentState.tableau) {
        for (let i = 0; i < tableau.length; i++) {
            const isTop = i === tableau.length - 1
            drawCard(tableau[i], ctx, isTop)
        }
    }
}

export function drawDraggedCards(ctx: CanvasRenderingContext2D) {
    const draggedCards = getDraggedCards()
    for (let i = 0; i < draggedCards.length; i++) {
        // When dragging a stack, only the bottom card (first) is fully visible;
        // but since they're being dragged freely, show suit on all of them
        drawCard(draggedCards[i], ctx, true)
    }
}
